export default { sha: '496b51fdbe2d921cb52565dd94483e61d3cf4fe1', buildNumber: 'undefined' }
